export default __webpack_public_path__ + "paras.ab395b86.png";